<template>
  <input
    v-model="inputValue"
    class="form-control me-3 my-1"
    type="text"
    placeholder="New Email"
  />
  <button
    type="button"
    class="btn btn-primary btn-sm mx-2"
    @click="changeUserEmail"
  >
    Update
  </button>
  <button
    type="button"
    class="btn btn-danger btn-sm mx-2"
    @click="deactivateComponentFunc()"
  >
    Close
  </button>
</template>

<script lang="ts">
import { updateEmail } from '@/common/api';
import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'AdminTableChangeEmailButton',

  props: {
    recordId: {
      type: Number,
      required: true,
    },
    deactivateComponentFunc: {
      type: Function,
      required: true,
    },
    reloadAdminTable: {
      type: Function,
      required: true,
    },
    recreateTableFunc: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      inputValue: '',
    };
  },

  methods: {
    async changeUserEmail() {
      try {
        await updateEmail(this.recordId, this.inputValue);
      } catch (error: unknown) {
        handleError(error, 'Failed to update email');
      }

      this.deactivateComponentFunc();
      this.recreateTableFunc();
    },
  },
});
</script>
